import React, { Component } from 'react'
import { Map, Marker, TileLayer } from 'react-leaflet'
import MarkerIcon from './MarkerIcon'
import 'leaflet/dist/leaflet.css'

class CustomMap extends Component {
  state = { lat: 43.216872, lng: 27.952343, zoom: 16 }

  render() {
	const position = [this.state.lat, this.state.lng]
	const { className }  = this.props
    return <Map className={`c-map ${className}`} center={position} zoom={this.state.zoom} minZoom={16} maxzoom={this.state.zoom}>
	    <TileLayer
          	attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		  	url='http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
			  maxZoom={16}
        />
        <Marker position={position} icon={MarkerIcon} />
      </Map>
  }
}

export default CustomMap



// WEBPACK FOOTER //
// ./src/components/Map.js